import {
    ADDTOCART_DETAILS_GET_REQUEST,
    ADDTOCART_DETAILS_RESET,
    SET_INTERSTITIAL_SKU_ID,
    SET_INTERSTITIAL_ITEM,
    CARE_PLAN_WARRANTY_REQUEST,
    CARE_PLAN_WARRANTY_SET_API_STATUS,
} from '../actionTypes/AddToCartInterstitialActionTypes';

export const getCartDetailsAction = (payload) => ({
    type: ADDTOCART_DETAILS_GET_REQUEST,
    payload,
});

export const resetCartDetailsAction = () => ({
    type: ADDTOCART_DETAILS_RESET,
});

export const setInterstitialSkuId = (payload) => ({
    type: SET_INTERSTITIAL_SKU_ID,
    payload,
});

export const setInterstitialItem = (payload) => ({
    type: SET_INTERSTITIAL_ITEM,
    payload,
});

export const getCarePlanWarrantyDetails = (payload) => ({
    type: CARE_PLAN_WARRANTY_REQUEST,
    payload,
});
export const carePlanWarrantySetApiStatus = (status) => ({
    type: CARE_PLAN_WARRANTY_SET_API_STATUS,
    status,
});
